import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";

function SustainabilityCounter({
  title,
  value,
  unit,
  info,
  lastOfType,
  mobFontSize,
}) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Text fontSize={[18, 18, 22, 22]} color="white" uppercase mb="-5px">
        {title}
      </Text>
      <Text
        fontFamily="ibmPlexMono"
        uppercase
        color="mint"
        fontSize={[
          mobFontSize ? mobFontSize : 84,
          mobFontSize ? mobFontSize : 84,
          104,
          104,
        ]}
        lineHeight={1}
        my={[32, null, 40, null]}
      >
        {value}
      </Text>
      {unit && (
        <Text fontSize={[18, 18, 22, 22]} color="white" uppercase>
          {unit}
        </Text>
      )}
      {info && (
        <Text
          fontSize={[14, 14, 14, 14]}
          lineHeight="24px"
          color="white"
          textAlign="center"
        >
          {info}
        </Text>
      )}
    </Box>
  );
}

export default SustainabilityCounter;

SustainabilityCounter.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  unit: PropTypes.string,
  info: PropTypes.string,
  lastOfType: PropTypes.bool,
};
